import React, { useState } from "react";
import { ArrowLeft, Mail } from "lucide-react";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api from "../lib/api";

export default function ForgotPassword({ onNavigate }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.forgotPassword(email);
      setSent(true);
      if (res.reset_token) {
        setDevLink(`${window.location.origin}/?reset_token=${res.reset_token}`);
      }
    } catch (err) {
      toast.error("Something went wrong", { description: err.message });
    } finally { setBusy(false); }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ink px-5">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-brand/15 blur-[150px]" />
      <div className="relative w-full max-w-md">
        <button onClick={() => onNavigate("login")} className="mb-8 inline-flex items-center gap-2 text-sm text-mist-muted transition-colors hover:text-mist">
          <ArrowLeft size={15} /> Back to sign in
        </button>
        <div className="glass rounded-[2rem] p-8">
          <Logo size={30} />
          <h1 className="mt-7 text-3xl font-semibold text-mist">Reset your password</h1>
          {!sent ? (
            <>
              <p className="mt-2 text-sm text-mist-muted">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="mt-8 space-y-4">
                <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 focus-within:border-brand">
                  <Mail size={16} className="text-mist-muted" />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com" data-testid="forgot-email-input"
                    className="w-full bg-transparent text-sm text-mist outline-none placeholder:text-mist-muted/60" />
                </div>
                <button type="submit" disabled={busy} data-testid="forgot-submit-btn" className={`btn-primary w-full ${busy ? "opacity-60" : ""}`}>
                  {busy ? "Sending…" : "Send reset link"}
                </button>
              </form>
            </>
          ) : (
            <div className="mt-4" data-testid="forgot-sent">
              <p className="text-sm text-mist-muted">If an account exists for <span className="text-mist">{email}</span>, a reset link is on its way.</p>
              {devLink && (
                <div className="mt-5 rounded-xl border border-brand/30 bg-brand/[0.06] p-4">
                  <p className="text-xs text-brand-soft">Email isn't connected yet — use this reset link:</p>
                  <a href={devLink} data-testid="forgot-dev-link" className="mt-2 block break-all text-xs text-brand underline">{devLink}</a>
                </div>
              )}
              <button onClick={() => onNavigate("login")} className="btn-ghost mt-6 w-full">Back to sign in</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
